const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d8b355cc0bc96094b4b9af6ff22c116aeb94155a"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"d8b355cc0bc96094b4b9af6ff22c116aeb94155a"};
      